import { render, staticRenderFns } from "./ModalAvatarUpload.vue?vue&type=template&id=334d52e2&scoped=true"
import script from "./ModalAvatarUpload.vue?vue&type=script&lang=js"
export * from "./ModalAvatarUpload.vue?vue&type=script&lang=js"
import style0 from "./ModalAvatarUpload.vue?vue&type=style&index=0&id=334d52e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334d52e2",
  null
  
)

export default component.exports